module.exports = __webpack_public_path__ + "img/bord-cote.303eb9b5.svg";